export const FILTERPUSH_SET_OPEN = 'FILTERPUSH_SET_OPEN';
export const FILTERPUSH_SET_CLOSED = 'FILTERPUSH_SET_CLOSED';

export const setFilterPushOpen = () => ({ type: FILTERPUSH_SET_OPEN });
export const setFilterPushClosed = () => ({ type: FILTERPUSH_SET_CLOSED });
